import { ListTableColumn, createListTableColumns, renderBooleanIcon, ListActionButtonProps } from "sprint-common-web";

import { renderContentSources } from "../../common/utils/renderContentSources";
import { getTvSeriesDashboardHref } from "../../ContentRoutes";
import { AddTvSeriesToMergeListButton } from "./buttons/TvSeriesMergeButton";
import { ViewTvSeriesAssetButton } from "./buttons/ViewTvSeriesAssetButton";
import { TvSeriesListingItem } from "./TvSeriesListingItem";

export interface CreateTvSeriesLisitngColumnsProps {
    tvSeriesToMerge: TvSeriesListingItem[];
    tvSeriesListingItems: TvSeriesListingItem[];
    addTvSeriesItemToMergeList(tvSeries: TvSeriesListingItem): void;
}

export const createTvSeriesLisitngColumns = ({
    tvSeriesToMerge,
    tvSeriesListingItems,
    addTvSeriesItemToMergeList
}: CreateTvSeriesLisitngColumnsProps): ListTableColumn<TvSeriesListingItem>[] =>
    createListTableColumns<TvSeriesListingItem>([
        {
            type: "link",
            key: "title",
            name: "Title",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true,
            getHref: (item) => getTvSeriesDashboardHref(item.id),
            isDisabled: (item) => item.merged || false
        },
        {
            type: "basic",
            key: "merged",
            name: "Merged",
            minWidth: 70,
            maxWidth: 70,
            isSortable: false,
            onRender: renderBooleanIcon
        },
        {
            type: "basic",
            key: "includedSources",
            name: "Source",
            minWidth: 120,
            maxWidth: 160,
            isSortable: false,
            onRender: renderContentSources
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 64,
            maxWidth: 96,
            buttons: [
                {
                    id: "merge",
                    onItemInvoked: addTvSeriesItemToMergeList,
                    render: (renderProps: ListActionButtonProps) =>
                        AddTvSeriesToMergeListButton({
                            ...renderProps,
                            tvSeriesToMerge,
                            tvSeriesList: tvSeriesListingItems
                        })
                },
                {
                    id: "viewAssets",
                    render: ViewTvSeriesAssetButton
                }
            ]
        }
    ]);
